import { Component, HostListener, OnInit, inject } from '@angular/core';
import { MODAL } from '../../services/modal.service';
import { environment } from '../../../environments/environment';
import { Key } from 'ts-keycode-enum';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { Project } from 'src/app/models/project';
import { getAppGtmRef, getAppUrl } from 'src/app/services/helpers/app-context-helper';
import { GTM } from 'src/app/services/gtm.service';
import { faChevronLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { ProjectListBaseComponent } from './project-list-base.component';

@Component({
  selector: 'ng-casto-projects',
  templateUrl: './projects.component.html',
})
export class ProjectsComponent extends ProjectListBaseComponent implements OnInit {
  vendorContext: boolean;
  private readonly LOCAL_STORAGE_LAST_CONTEXT_TOKEN = 'last-context';

  protected override get createProjectButtonId(): string {
    return 'search-bar-create-project-modal';
  }

  private readonly gtm = inject(GTM);
  private readonly tunnelDataStore = inject(TunnelDataStore);

  constructor() {
    super();
    this.vendorContext = environment.vendor;
  }

  override ngOnInit(): void {
    this.loading = true;
    this.loadingProjects = true;

    if (this.modalService.currentDatas?.tabKey) {
      this.currentTab = this.modalService.currentDatas.tabKey;
      this.gtm.trackPage('mes-projets', getAppGtmRef(this.modalService.currentDatas.tabKey));
    } else {
      this.gtm.trackPage('mes-projets', 'tous');
    }

    if (this.contextToDisplay) this.setTab(this.contextToDisplay);

    super.ngOnInit();
  }

  protected override setTab(tab: string): void {
    super.setTab(tab);
    this.gtm.trackPage('mes-projets', tab === 'all' ? 'tous' : getAppGtmRef(tab));
  }

  protected override navigateToProject(project: Project): void {
    super.navigateToProject(project);
    this.gtm.trackEvent('selectionner-projet-overlay', {
      projetType: getAppGtmRef(project.distributionID),
      projectId: project.projectUUID,
    });
  }

  protected override afterNavigate(): void {
    this.modalService.close();
  }

  protected override afterProjectsChanged(): void {
    this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.id });
  }

  protected override afterProjectDeleteCancelled(): void {
    this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.id });
  }

  protected override afterProjectDuplicateCancelled(): void {
    this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.id });
  }

  get contextToDisplay() {
    return this.modalService.currentDatas?.contextToDisplay;
  }

  protected backToCustomerSearch(): void {
    if (this.modalService.currentDatas) {
      this.modalService.display(MODAL.SEARCH_CUSTOMER, {
        defaultValue: this.modalService.currentDatas?.defaultValue ?? '',
        selectProject: true,
        configContext: this.modalService.currentDatas?.contextToDisplay ?? 'all',
      });
    } else {
      this.close();
    }
  }

  protected close(): void {
    this.tunnelDataStore.resetCurrentCustomer();
    this.modalService.close();
  }

  protected newProject(event: Event): void {
    event.stopPropagation();
    this.gtm.trackEvent('creer-projet-overlay', { projectType: getAppGtmRef(this.currentTab) });
    this.sendNewProjectCountStatistic(this.currentTab);

    this.customer.context = this.currentTab;
    if (this.currentTab === 'kitchen' || this.currentTab === 'storage') {
      this.router.navigate(['tunnel']);
    } else if (this.currentTab === CONFIG_CONTEXT.BATHROOM || this.currentTab === CONFIG_CONTEXT.BATHROOM_V2) {
      this.router.navigate(['salle-de-bain']);
    } else if (this.configurators2d.includes(this.currentTab)) {
      this.router.navigate([getAppUrl(this.currentTab), 'configuration']);
    }
    this.modalService.close();
  }

  private updateStorageLastContext(context: CONFIG_CONTEXT): void {
    localStorage.setItem(this.LOCAL_STORAGE_LAST_CONTEXT_TOKEN, context);
  }

  protected override openConfigurator(context: CONFIG_CONTEXT): void {
    this.updateStorageLastContext(context);
    super.openConfigurator(context);
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.which === Key.Enter) {
      this.filterDisplayedProjects();
    }
  }

  protected readonly faPlus = faPlus;
  protected readonly faChevronLeft = faChevronLeft;
}
